import React, { useRef, useEffect } from "react";
import "../css/personalaccidentalinsurance.css";
import personalaccidentalinsuranceimg from "../assets/personalaccidentalinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from 'react-helmet-async';

const PersonalAccidentalInsurance = () => {
    const API_URL = process.env.REACT_APP_Dashboard_API_URL;
    const imageRefs = useRef([]);
    const imageSources = [
        personalaccidentalinsuranceimg,
        tollfreenumberimg
    ];

    useEffect(() => {
        if (imageRefs.current.length > 0) {
            let index = 0;
            const showNextImage = () => {
                imageRefs.current.forEach((img, i) => {
                    if (img) img.style.display = i === index ? "block" : "none";
                });
                index++;
                if (index >= imageRefs.current.length) index = 0;
                setTimeout(showNextImage, 3000);
            };
            showNextImage();
        }
    }, []);

    const handleSubmit = async (data) => {
        const inquriyData = new FormData();
        inquriyData.append("Name", data.Name);
        inquriyData.append("Email", data.Email);
        inquriyData.append("PreferredDate", data.Date);
        inquriyData.append("PreferredTime", data.Time);
        inquriyData.append("MobileNo", data.MobileNo);
        inquriyData.append("Status", "New");
        inquriyData.append("UserId", data.Id);
        inquriyData.append("InquiryType", "Insurance Inquiries");
        inquriyData.append("PolicyType", "Personal/Accidental Insurance");
        inquriyData.append("IsLoggedIn", data.isLoggedIn);
        inquriyData.append("Otp", data.OTP);

        try {
            const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return { status: response.status, data: response.data };
        } catch (error) {
            return {
                status: 500,
                data: { success: false, message: error.response?.data?.message }
            };
        }
    };

    return (
        <div className="personalaccidentalinsurance-container">
            <Helmet>
                <title>Personal Accidental Insurance Guidance | Stay Covered</title>
                <meta name="description" content="Get expert advice on personal accidental insurance. Learn how to protect yourself and your family from unexpected accidents." />
                <link rel="canonical" href="https://policysamjho.com/personal-accidental-insurance-guidance/" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Personal Accidental Insurance Guidance",
                        "description": "Get clear advice on personal accidental insurance to protect yourself and your family from unexpected accidents. Policy Samjho makes it simple.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Policy Samjho",
                            "url": "https://policysamjho.com/"
                        },
                        "serviceType": "Personal Accident Insurance Consultation",
                        "areaServed": "IN",
                        "url": "https://policysamjho.com/personal-accidental-insurance-guidance/",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91-9584484800",
                            "email": "info@policysamjho.com",
                            "contactType": "customer service"
                        }
                    })}
                </script>
            </Helmet>

            <div className="personalaccidentalinsurance-hero-container">
                <div className="personalaccidentalinsurance-hero-text-box">
                    <h1>
                        <span style={{ color: '#192437' }}>Personal Accidental </span>
                        <span style={{ color: '#F5A526' }}>Insurance Guidance</span>
                    </h1>
                    <p style={{ color: "black", fontWeight: "600", fontSize: "18px", textAlign: 'justify' }}>
                        Ensure financial security in case of accidents with comprehensive personal accidental insurance coverage.
                    </p>
                </div>
                <div className="personalaccidentalinsurance-imgslider">
                    {imageSources.map((image, index) => (
                        <img
                            key={index}
                            ref={(el) => (imageRefs.current[index] = el)}
                            src={image}
                            className="personalaccidentalinsurance-sliderimg"
                            alt={`personalaccidentalinsurance-slide-${index}`}
                            style={{ display: index === 0 ? "block" : "none" }}
                        />
                    ))}
                </div>
            </div>

            <div className="personalaccidentalinsurance-containform-container">
                <div className="col-md-6 personalaccidentalinsurance-info">
                    <h2 className="personalaccidentalinsurance-heading">
                        <span style={{ color: '#192437' }}>What is </span>
                        <span style={{ color: '#F5A526' }}>Personal Accidental Insurance?</span>
                    </h2>
                    <p className="personalaccidentalinsurance-text">
                        Personal accidental insurance provides coverage for medical expenses, disability, and loss of income due to accidents.
                    </p>

                    <h2 className="personalaccidentalinsurance-subheading">
                        <span style={{ color: '#192437' }}>Why is Personal </span>
                        <span style={{ color: '#F5A526' }}>Accidental Insurance Important?</span>
                    </h2>
                    <ul className="personalaccidentalinsurance-benefits">
                        <li className="insurancepoints">Coverage for hospitalization expenses</li>
                        <li className="insurancepoints">Compensation for disability and income loss</li>
                        <li className="insurancepoints">Support for medical treatments and recovery</li>
                        <li className="insurancepoints">Financial security in case of accidental injuries</li>
                    </ul>

                    <h2 className="personalaccidentalinsurance-subheading">
                        <span style={{ color: '#192437' }}>Comprehensive Coverage & </span>
                        <span style={{ color: '#F5A526' }}>Insurance Benefits</span>
                    </h2>
                    <p className="personalaccidentalinsurance-text spaced-text">
                        Personal accidental insurance safeguards you and your family against financial burdens caused by unexpected accidents.
                    </p>
                </div>

                <div>
                    <h4 className="consultationform-heading">
                        <span style={{ color: "#192437" }}>Get a Free Personal </span>
                        <span style={{ color: "#F5A526" }}> Accidental Insurance Quote </span>
                    </h4>
                    <ConsultationForm onSubmit={handleSubmit} />
                </div>
            </div>

            <PoliciesSlider category="Personal/Accidental Insurance" />
            <ChatbotAi />
        </div>
    );
};

export default PersonalAccidentalInsurance;